var _defs, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReloj(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #00dbdc;\r\n        opacity: .1;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #04808f;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20.52,10.02c-.28,0-.5-.22-.5-.5s.22-.5,.5-.5h3.69c-2.02-3.09-5.47-5-9.19-5-6.06,0-11,4.93-11,11s4.93,11,11,11c1.5,0,2.29-.22,2.9-.39,.28-.07,.54,.09,.61,.35,.07,.27-.09,.54-.35,.61-.67,.18-1.66,.42-3.16,.42-6.62,0-12-5.38-12-12S8.4,3.02,15.02,3.02c4.04,0,7.79,2.07,10,5.41v-3.91c0-.28,.22-.5,.5-.5s.5,.22,.5,.5v4c0,.83-.67,1.5-1.5,1.5h-4Zm6,4.5c-.28,0-.5,.22-.5,.5,0,.64-.06,1.28-.16,1.9-.05,.27,.14,.53,.41,.58,.03,0,.06,0,.09,0,.24,0,.45-.17,.49-.41,.12-.68,.18-1.38,.18-2.07,0-.28-.22-.5-.5-.5Zm-.85,4.89c-.25-.12-.55,0-.66,.24-.27,.58-.59,1.13-.95,1.66-.16,.23-.1,.54,.12,.7,.09,.06,.19,.09,.29,.09,.16,0,.31-.07,.41-.21,.4-.57,.75-1.18,1.04-1.81,.12-.25,0-.55-.24-.66h0Zm-3.55,4.01c-.49,.41-1.01,.78-1.56,1.1-.24,.14-.32,.44-.18,.68,.09,.16,.26,.25,.43,.25,.09,0,.17-.02,.25-.07,.6-.35,1.17-.75,1.7-1.2,.21-.18,.24-.49,.06-.7-.18-.21-.49-.23-.7-.06h0Zm-2.36-6.34l-4.24-2.32v-6.24c0-.28-.22-.5-.5-.5s-.5,.22-.5,.5v6.54c0,.18,.1,.35,.26,.44l4.5,2.46c.08,.04,.16,.06,.24,.06,.18,0,.35-.09,.44-.26,.13-.24,.04-.55-.2-.68Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 14.52,
    cy: 14.52,
    r: 11.54
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReloj);
export default __webpack_public_path__ + "static/media/Reloj.2b7ea25bf40a55a24bcc4239e1438572.svg";
export { ForwardRef as ReactComponent };